<template>
    <span class="fi fh fa-c" :class="[isEmpty ? 'el--empty' : '']" style="flex-shrink: 0;">
        <template v-if="!isEmpty">
            <span class="ath-visual-number-basic-value">{{ value }}</span>
            <Trend v-if="trend !== false"
                :value="trend"
                class="sm-l-xs"
                :colorize="1" />
        </template>
        <span v-else>{{ fallback }}</span>
    </span>
</template>

<script>
import { isNeString, isNumber } from '@aretheyhappy/utils';
import Trend from './Trend.vue';

export default {
    name: 'mead-number-basic',
    props: {
        /**
         * Trend value to render via the `Trend` indicator (colorized using the
         * standard positive/negative scheme). Defaults to `false`, which hides
         * the trend indicator.
         */
        trend: {type: [Number, Boolean], default: false},
        /**
         * Value to render when `value` is empty (not a number or non-empty string).
         */
        fallback: {type: [Number, String], default: () => 0},
        /**
         * The value to display. When neither a number nor a non-empty string, the
         * component is considered empty and shows `fallback` instead.
         */
        value: {type: [Number, String, Boolean], default: false},
    },
    components: {Trend},
    computed: {
        isEmpty: function () {
            return !isNumber(this.value) && !isNeString(this.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.ath-visual-trend.fas-r {
    transform: translateY(-.4rem);
}

.el--empty {
    opacity: .25;
}

.ath-visual-number-basic-value {
    &.el--t-positive {
        color: var(--c-sentiment-positive-bg);
    }

    &.el--t-negative {
        color: var(--c-sentiment-negative-bg);
    }
}
</style>
